import { Pipe, PipeTransform } from '@angular/core'
import { AppState } from '../../core/core.state'
import { participationSelectors } from '../booking/participation/participation.selectors'
import { Store } from '@ngrx/store'
import { saleItemSelectors } from '../sale/sale-item/sale-item.selectors'
import { saleSelectors } from '../sale/sale.selectors'
import { combineLatest, Observable } from 'rxjs'
import { map, take } from 'rxjs/operators'
import { SaleItem } from '../sale/sale-item/sale-item'
import moment from 'moment-mini'
import { ConfigurationService } from '../../shared/services/configuration.service'
import { Moment } from 'moment-mini'
import { DatePipe } from '@angular/common'
import { bookingSelectors } from '../booking/booking.selectors'

@Pipe({
  name: 'participationIdToSaleItemDateRange'
})
export class ParticipationIdToSaleItemDateRangePipe implements PipeTransform {
  participationEntities$ = this.store.select(
    participationSelectors.selectEntities
  )
  saleItemEntities$ = this.store.select(saleItemSelectors.selectEntities)
  saleEntities$ = this.store.select(saleSelectors.selectEntities)
  bookingEntities$ = this.store.select(bookingSelectors.selectEntities)

  constructor(
    private store: Store<AppState>,
    private configurationService: ConfigurationService
  ) {}

  transform(participationId: number): Observable<string> {
    return combineLatest([
      this.participationEntities$,
      this.saleEntities$,
      this.saleItemEntities$,
      this.bookingEntities$,
      this.configurationService.selectedLang$
    ]).pipe(
      map(
        ([
          participationEntities,
          saleEntities,
          saleItemEntities,
          bookingEntities,
          selectedLang
        ]) => {
          const datePipe = new DatePipe(selectedLang)

          const participation = participationEntities[participationId]
          const saleItem = saleItemEntities[participation?.saleItemId]
          const sale = saleEntities[saleItem?.saleId]
          const booking = bookingEntities[participation?.bookingId]

          if (!sale || !booking.startDate || !booking.endDate) {
            return ''
          }

          const saleSaleItems: { startDate: Moment; endDate: Moment }[] =
            sale?.saleItems
              ?.map((saleItemId) => saleItemEntities[saleItemId])
              .map((s: SaleItem) => ({
                startDate: moment(s.params?.startDate),
                endDate: moment(s.params?.endDate)
              }))
          const format = 'dd/MM/YYYY'

          try {
            if (saleSaleItems.length === 0) {
              return `${datePipe.transform(
                // @ts-ignore
                booking.startDate,
                format
                // @ts-ignore
              )} - ${datePipe.transform(booking.endDate, format)}`
            }

            const startDate = saleSaleItems.reduce(
              (acc, curr) =>
                acc.startDate.isBefore(curr.startDate) ? acc : curr,
              saleSaleItems[0]
            ).startDate

            const endDate = saleSaleItems.reduce(
              (acc, curr) => (acc.endDate.isAfter(curr.endDate) ? acc : curr),
              saleSaleItems[0]
            ).endDate

            if (!startDate.isValid() || !endDate.isValid()) {
              return ''
            }

            return `${datePipe.transform(
              startDate.toDate(),
              format
            )} - ${datePipe.transform(endDate.toDate(), format)}`
          } catch (e) {
            console.log(e)
            return ''
          }
        }
      )
    )
  }
}
